export const convertToViewPageUrl = (url?: string): string =>
	// oxlint-disable-next-line typescript/no-non-null-assertion
	url!
		.split('/')
		.filter((part) => part !== 'edit-v2')
		.join('/');
